import React from 'react'
import { StatBadge } from '../editorial/StatBadge'
import type { FileRecord } from '../../lib/storage/types'

export interface TelemetryGridProps {
  records: FileRecord[]
}

function formatMB(bytes: number): string {
  if (bytes <= 0) return '0.0 MB'
  const mb = bytes / (1024 * 1024)
  return `${mb.toFixed(1)} MB`
}

export const TelemetryGrid: React.FC<TelemetryGridProps> = ({ records }) => {
  const completed = records.filter((r) => r.status === 'done')
  const totalCount = records.length
  const completedCount = completed.length

  let totalOriginalBytes = 0
  let totalSavedBytes = 0
  let savingsSum = 0
  let savingsCount = 0

  for (const record of completed) {
    totalOriginalBytes += record.originalSize
    if (record.results && record.results.length > 0) {
      // Find the primary/best compressed output for telemetry calculation
      const validResults = record.results.filter((res) => res.size > 0)
      if (validResults.length > 0) {
        const smallest = Math.min(...validResults.map((res) => res.size))
        const savedForThis = Math.max(0, record.originalSize - smallest)
        totalSavedBytes += savedForThis

        const percent = Math.round((1 - smallest / record.originalSize) * 100)
        savingsSum += Math.max(0, percent)
        savingsCount++
      }
    }
  }

  const avgSavings = savingsCount > 0 ? Math.round(savingsSum / savingsCount) : 0

  return (
    <div
      style={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
        gap: '16px',
        marginBottom: '32px',
      }}
    >
      <StatBadge
        value={`${completedCount} / ${totalCount}`}
        label="Archivos Procesados"
      />

      <StatBadge
        value={`-${avgSavings}%`}
        label="Ahorro Promedio"
        pulse={avgSavings > 0}
        trend={avgSavings > 50 ? 'ALTO RENDIMIENTO' : undefined}
      />

      <StatBadge
        value={formatMB(totalSavedBytes)}
        label="Volumen Ahorrado"
        pulse={totalSavedBytes > 0}
      />

      <StatBadge
        value="0 ms"
        label="Latencia de Red"
        trend="100% EN DISCO"
      />
    </div>
  )
}
